var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    { attrs: { trigger: "click" }, on: { command: _vm.handleChange } },
    [
      _c(
        "el-tooltip",
        {
          attrs: { effect: "dark", content: _vm.item.label, placement: "top" },
        },
        [
          _c("div", { staticClass: "padding-5 pointer flex-center" }, [
            _c("img", {
              style: {
                width: _vm.item.size + "px",
                height: _vm.item.size + "px",
              },
              attrs: { src: _vm.item.icon },
            }),
          ]),
        ]
      ),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        _vm._l(_vm.item.list, function (item) {
          return _c(
            "el-dropdown-item",
            { key: item.value, attrs: { command: item.value } },
            [_vm._v("\n      " + _vm._s(item.label) + "\n    ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }